import React from 'react';

const Step9Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-9">
        Si stima che per ricaricare un’auto elettrica utilitaria sono necessari mediamente 1.200 kWh/anno; questa è un'importante informazione sulle tue caratteristiche di consumo attuali e future.
        </div>
    );
}

export default Step9Infos;